import { useMemo } from "react";
import { EditMenuService } from "../service/editMenuService";

type UseCloneDishModalFormDataProps = {
    categories: any[] | null;
    currentCategoryId: number | null;
    currentSubcategoryId: number | null;
    isTranslationMode: boolean;
};

export const useCloneDishModalFormData = ({
    categories,
    currentCategoryId,
    currentSubcategoryId,
    isTranslationMode,
}: UseCloneDishModalFormDataProps) => {
    const serviceCategories = useMemo(() => {
        if (!categories) {
            return null;
        }

        return EditMenuService.categoryModuleCreator(
            categories,
            currentCategoryId,
            currentSubcategoryId,
            isTranslationMode
        );
    }, [categories, currentCategoryId, currentSubcategoryId, isTranslationMode]);

    return {
        serviceCategories,
    };
};
